// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p-dataview {
  position: relative;
}

p-dataview .p-dataview-loading-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

p-dataview .p-dataview.p-dataview-list .p-dataview-content .p-grid div:first-child {
  border-top: none !important;
}
p-dataview c-dataviewlayoutoptions p-button.p-highlight {
  filter: brightness(0.85);
}
p-dataview c-dataviewlayoutoptions p-button button {
  border-radius: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/component/dataview/dataview.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAOgB;EACI,2BAAA;AAJpB;AAaY;EACI,wBAAA;AAXhB;AAcY;EACI,6BAAA;AAZhB","sourcesContent":["p-dataview {\n    position: relative;\n}\n\np-dataview .p-dataview-loading-overlay {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n}\n\np-dataview {\n\n    .p-dataview.p-dataview-list {\n        .p-dataview-content {\n            .p-grid {\n                div:first-child {\n                    border-top: none !important;\n                }\n            }\n        }\n    }\n\n    c-dataviewlayoutoptions {\n\n        p-button {\n            &.p-highlight {\n                filter: brightness(0.85);\n            }\n\n            button {\n                border-radius: 4px !important;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
